import type { ButtonStyledProps } from './Button.styled';
import { ButtonStyled } from './Button.styled';

export const Button = (props: ButtonStyledProps) => {
  return <ButtonStyled {...props} />;
};
